import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService, private router: Router) { }

    private handleAuthError(err: HttpErrorResponse): Observable<any> {
        return throwError(err);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let headers: any = {
            'x-access-pdv': environment.xAccessPdv,
            'x-access-token': environment.xAccessToken,
            'company-id': environment.companyId
        };

        // caso quem esteja logado seja o cliente
        if (this.authService.isLoggednIn()) {
          if (this.authService.getCustomer()['fengIntegration'] != null &&
          this.authService.getCustomer()['fengIntegration'] == true) {
              headers = {
                'x-access-pdv': '519d1ac1-20c8-4179-91f2-dbe88896b5fa',
                'x-access-token': '99ozz9bgcp2vwhd1d5q9mmz0i1t7chcmkrhnaodpeumofzraf58yltkcyq1w69tb'
              }
          }
          headers['x-customer-token'] = this.authService.getCustomer().token;
        }

        if (environment.newIntegration == true) {
          headers = {
            'x-access-pdv': '748f1e20-a20d-41c4-97c9-06253fd4adec',
            'x-access-token': '00stisagcp2vwhd1d5q9mmz0i1t7chcmkrhnaodpeumofzraf58yltkcyq1w0000'
          }
        }
      
        // caso quem esteja logado seja o produtor e esteja na página do produtor
        if (this.authService.isProducerLoggednIn() && this.router.routerState.snapshot.url.indexOf("/producer") > -1)  {
            if (request.headers.has('courtesy-token')) {
              headers['x-access-token'] = environment.courtesyAccessToken;
            } else  {
              // token de acesso para o painel do produtor (produtor logado)
              headers['x-access-token'] = this.authService.getProducer().token;
            }

          // remove token pdv e customer pois produtor não tem pdv nem customer
          delete headers['x-access-pdv']
        }

        if (request.headers.has('x-skip-interceptor')) {
          request.headers.delete('x-skip-interceptor');
          request.headers.delete('x-access-pdv');
          request.headers.delete('x-access-token');
          let headers: any = request.headers.delete('x-skip-interceptor', 'x-skip-interceptor');
          request = request.clone({headers});
        } else {
          request = request.clone({ setHeaders: headers });
        }

        // caso tenha o cabeçalho x-commissarysell, o interceptador irá substituir o x access pdv e access token
        // pelo access pdv e token do comissário
        if (this.authService?.getCustomer()?.modeComissioner && environment.xCommissaryAccessPdv && environment.xCommissaryAccessToken) {
          delete headers['x-access-pdv']
          delete headers['x-access-token']
          headers['x-access-pdv'] = environment.xCommissaryAccessPdv
          headers['x-access-token'] = environment.xCommissaryAccessToken
          request = request.clone({ setHeaders: headers });
        } else {
          request = request.clone({ setHeaders: headers });
        }

        return next.handle(request)
            .pipe(catchError(err => this.handleAuthError(err)));
    }
}
